<template>
  <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :before-close="handleClose"
      width="30%"
      class="my-dialog"
      :close-on-click-modal=false
  >
    <div class="wh100">
      <el-form
          ref="editForm"
          :model="editForm"
          label-position="right"
          label-width="150px"
          :rules="rules"
      >
        <el-row type="flex" justify="left">
          <el-col :span="20">
            <el-form-item label="运维单位名称" prop="operateUnitName"
            ><el-input v-model="editForm.operateUnitName" clearable></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row  type="flex" justify="left">
          <el-col :span="20">
            <el-form-item label="是否可用">
              <el-radio-group v-model="editForm.isEnable">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <el-row type="flex" justify="left">
          <el-col :span="20">
            <el-form-item label="上级区域" prop="parentId">
              <el-cascader
                  ref="areaRef"
                  style="width: 100%"
                  :options="areaTreeList"
                  v-model="editForm.parentId"
                  :show-all-levels="true"
                  :props="areaProps"
                  @change="selectChange"
                  placeholder="请选择"
                  clearable
                  filterable
                  :disabled="isDisabled(editForm.id)"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>-->
      </el-form>
      <div align="center">
        <el-button type="primary" @click="submit('editForm')">保存</el-button>
        <el-button type="danger" @click="handleClose">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {
  },
  props: ["options","title"],
  data() {
    let _this =this;
    return {
      dialog: {
        title: this.title,
        visible: false,
      },
      editForm: {
        id: "",
        operateUnitName:"",
        areaId: "",
        isEnable:1,
      },
      rules: {
        operateUnitName: [{required: true,message: "必填项", trigger: "blur"}],
      },
      areaList:[],
      areaProps: {value: 'id', checkStrictly: true,emitPath:false},
      areaTreeList:[],
    };
  },
  methods: {
    init() {
      let that = this;
      that.dialog.visible = true;
      if (this.options) {
        that.editForm = this.options;
      }else {
        that.editForm =
            {
              id: "",
              operateUnitName:"",
              areaId: "",
              isEnable:1,

            }
      }

    },
    handleClose() {
      this.dialog.visible = false;
      this.$emit("closeModal");
    },
    submit(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
            if (valid) {
              _this.$api.post(
                  "/baseOperate/saveOrUpdate",
                  _this.editForm,
                  function (res) {
                    if (res.code === "200") {
                      _this.$message.success("保存成功！");
                      _this.dialog.visible = false;
                      _this.$emit("closeModal")
                    } else {
                      _this.$message.error("保存失败！");
                    }
                  }
              );
            }
          }
      )
    },
    loadAllArea() {
      let _this = this;
      _this.$api.get("/Area/getAreaInfoByTreePath",
          {
            treePath:this.$store.state.treePath,
          }
          , function (res) {
            if (res.code === "200") {
              _this.areaList = res.data;
              let obj ={id:"0",areaName:"无"}
              _this.areaList.push(obj);
            }
          });
    },
    getAreaTreeData() {
      let _this = this;
      this.$api.get("/Area/getAreaTreeData", {treePath:this.$store.state.loginInfo.treePath}, function(res) {
        if (res.code === "200") {
          _this.areaTreeList = res.data;
        } else {
        }
      });
    },
    selectChange(val) {
    },
  },
  mounted() {
    //this.loadAllArea();
    this.getAreaTreeData();
  },
  watch: {

  },

}
</script>

<style scoped>

</style>